module.exports = __webpack_public_path__ + "tunderujjak.jpg?34b55305394d91a07ae91dceb5d751b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tunderujjak.jpg
// module id = 28
// module chunks = 0